module.exports = __webpack_public_path__ + "img/class_logo.2772e84f.png";